import { useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import { Spinner } from "../../../common"

/**
 * Loading indicator shown while a sourcing search is in flight.
 *
 * Pearch's fast-mode search routinely takes 20–60 seconds for complex
 * natural-language queries (semantic parse → 700M-profile index → scoring).
 * A bare spinner feels broken at that duration, so we show a progressive
 * message that advances through a few reassuring stages as the wait extends.
 */
const STAGES = [
  { at: 0, id: "sourcing.loading.parsing" },
  { at: 4, id: "sourcing.loading.searching" },
  { at: 15, id: "sourcing.loading.ranking" },
  { at: 30, id: "sourcing.loading.stillWorking" },
]

const SearchingIndicator = () => {
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const start = Date.now()
    const id = setInterval(() => {
      setElapsed(Math.floor((Date.now() - start) / 1000))
    }, 1000)
    return () => clearInterval(id)
  }, [])

  // Pick the latest stage whose threshold has been crossed.
  const stage = STAGES.reduce(
    (best, s) => (elapsed >= s.at ? s : best),
    STAGES[0]
  )

  return (
    <div className="sourcing-loading">
      <Spinner />
      <p className="sourcing-loading__message">
        <FormattedMessage id={stage.id} />
      </p>
    </div>
  )
}

export default SearchingIndicator
